import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

export const BannerBar = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.sm};
  padding: ${SPACING.md} ${SPACING.lg};
  background: var(--color-bg-secondary);
  border-bottom: 1px solid var(--color-border);
`

export const BannerLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const BannerTitle = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  white-space: nowrap;
`

export const PillsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
`

export const CategoryPill = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px 1px 5px;
  border-radius: 8px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-secondary);
  background: var(--color-bg-hover);
  white-space: nowrap;

  &::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
    flex-shrink: 0;
  }
`
